/** Lists shorter than this get no search box; there is nothing to look for. */
export const SALES_INSIGHTS_SEARCH_MIN_ROWS = 8;

/** Every word of the query has to appear in one of the values, ignoring case and accents. */
export function salesInsightsMatches(query: string, values: unknown[]): boolean {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (!words.length) {
    return true;
  }
  const haystack = values
    .filter(value => value !== null && value !== undefined && value !== '')
    .map(value => normalize(String(value)))
    .join(' ');
  return words.every(word => haystack.includes(word));
}

function normalize(text: string): string {
  return (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/ø/g, 'o')
    .replace(/æ/g, 'ae')
    .trim();
}
